// Library
import React from 'react';


const RightSection = () => <div className="right-section" />;
export default RightSection;
